$(() => {
    const emailInput = $('#subscription-email'),
        btnSubscribe = $('#subscription'),
        contextPath = $('meta[name=context-path]').attr('content').trim(),
        csrfToken =  $('meta[name=csrf-token]').attr('content').trim();

    btnSubscribe.click(() => subscribe(emailInput.val().trim()));

    function validateEmail (email) {
        const emailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return emailRegex.test(email);
    }

    function subscribe (email) {
        if (!validateEmail(email)) {
            emailInput.removeClass('is-valid');
            emailInput.addClass('is-invalid');
            emailInput.siblings('.invalid-feedback').fadeIn();
            return false;
        }
        $.post(contextPath + '/getshoppingUpdate?email=' + email + '&_tk=' + csrfToken, response => {
            emailInput.removeClass('is-invalid');
            emailInput.addClass('is-valid');
            emailInput.siblings('.valid-feedback')
                .find('p').text(response)
                .fadeIn();
        });
    }
});